import script from "./ContactHero.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactHero.vue?vue&type=script&setup=true&lang=js"

import "./ContactHero.vue?vue&type=style&index=0&id=4544414c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4544414c"]])

export default __exports__